const technical = [

];

export default technical;